import { render, staticRenderFns } from "./contact-tab.vue?vue&type=template&id=46c3113f&"
import script from "./contact-tab.vue?vue&type=script&lang=js&"
export * from "./contact-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports